module.exports = __webpack_public_path__ + "img/car_sendai26.49969b50.jpg";